import type { StoreApi } from "zustand";

import { getPlatform, isLocal } from "./utils";

type ConfigFn<T extends { data: Record<string, unknown> }> = (
  set: StoreApi<T>["setState"],
  get: StoreApi<T>["getState"],
  api: StoreApi<T>,
) => T;

// Define the log function with the correct types
export const log =
  <T extends { data: Record<string, unknown> }>(config: ConfigFn<T>) =>
  (set: StoreApi<T>["setState"], get: StoreApi<T>["getState"], api: StoreApi<T>) => {
    if (!isLocal || getPlatform() === "native") {
      return config(set, get, api);
    }

    return config(
      (partial, replace) => {
        console.groupCollapsed(
          `State - ${Object.keys(partial || {})[0] || "Unknown state change"}`,
        );
        console.log("Applying new state", partial);
        if (replace === true) {
          set(partial as T, replace);
        } else {
          set(partial, replace);
        }
        console.log("New State", get().data);
        console.groupEnd();
      },
      get,
      api,
    );
  };
